var $ = require('jquery');
require('matchHeight');

var self = {};

self.initialise = function() {
  self.calculateHeights = function() {
    $('.media__inner h3').matchHeight();
    $('.media__inner p').matchHeight();
    $('.panel-text-two, .inner-text').matchHeight();
    $('.panel-text-two, .panel-text').matchHeight();
    $('.reasons article h3').matchHeight();
    $('.reasons article p').matchHeight();
    $('.reasons .reason h3').matchHeight();
    $('.reasons .reason p').matchHeight();
    $('.carousel--home .actions__item a').matchHeight();
    $('.regional-column').matchHeight();
  };

  $(document).ready(self.calculateHeights);
  $(window).resize(self.calculateHeights);
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/match-height.js